import styled from 'styled-components';

export const ChartSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  left: -31px;
`;
